import {AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Injectable, OnInit} from '@angular/core';
import {Campus} from '../../model/Campus';
import {MatDialog, MatTabChangeEvent} from '@angular/material';
import {Router} from '@angular/router';
import {DataLoaderService} from '../../services/data-loader/data-loader.service';
import {GlobalService} from '../../services/global/global.service';
import {HttpClient} from '@angular/common/http';
import {DownloadAssetBundlePayload, EditCampusPayload} from '../../components/campus-card/campus-card.component';

@Component({
  selector: 'app-campus-list',
  templateUrl: './campus-list.component.html',
  styleUrls: ['./campus-list.component.css'],
})
export class CampusListComponent implements AfterViewInit {
  public campusList: Campus[] = [];
  public newCampusID: string;
  public loading: boolean;

  constructor(
    public http: HttpClient,
    public globalService: GlobalService,
    public dialogService: MatDialog,
    public dataLoader: DataLoaderService,
    public router: Router,
  ) {
    this.loading = true;
  }

  ngAfterViewInit(): void {
    this.globalService.GetReloadTrigger().subscribe(() => {
      this.fetchCampusList();
    });

    this.newCampusID = '';
    this.fetchCampusList();
  }

  public async fetchCampusList(): Promise<void> {
    this.loading = true;
    this.campusList = [];

    try {
      this.campusList = await this.dataLoader.FetchCampusList();
    } catch (err) {
      this.globalService.ShowMessage(err.message);
      console.error(err);
    }

    this.loading = false;
  }

  public async addCampus(): Promise<void> {
    this.loading = true;

    try {
      const id = await this.dataLoader.AddNewCampus(this.newCampusID);
      this.router.navigateByUrl('campus/' + id);
    } catch (err) {
      this.globalService.ShowMessage(err.message);
    }

    this.loading = false;
  }

  public backUpJSON(): string {
    return JSON.stringify(this.campusList.map((campus) => campus.AsData()), null, 4);
  }

  public selectedTabChange(event: MatTabChangeEvent): void {
    if (event.tab.textLabel === 'Site') {
      this.router.navigate(['site']);
    } else if (event.tab.textLabel === 'Apidoc') {
      window.location.href = './doc/index.html';
    }
  }

  public async downloadAssetBundle(payload: DownloadAssetBundlePayload): Promise<void> {
    try {
      location.href = await this.dataLoader.GetAssetbudleDownloadURL(payload.campus.id, payload.platform);
    } catch (err) {
      this.globalService.ShowMessage(err.message);
    }
  }

  public async triggerEdit(payload: EditCampusPayload): Promise<void> {
    this.router.navigate(['campus', payload.campus.id]);
  }
}
